// src/app/home-two/home-two.component.ts
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home-two',
  templateUrl: './home-two.component.html',
  styleUrls: ['./home-two.component.scss']
})
export class HomeTwoComponent implements OnInit {
    envName = environment.ENV;

  constructor() { }

    ngOnInit(): void {
        console.log('ENVIRONMENT =', this.envName);
    }
}
